import React from "react";
// outsource
import { Button, DatePicker, Select } from "antd";
import moment from "moment";

const weekFormat = "ddd DD/MM";
const startOfString = "week";
const REPORT_BY_OPTIONS = [
  { label: "Month", value: "month" },
  { label: "Week", value: "week" },
];

const PayoutReportToolbar = ({
  reportBy,
  currentMonthStart,
  currentWeekStart,
  handleReportByChange,
  handlePeriodChange,
  handlePreviousPeriod,
  handleNextPeriod,
  nextDisabled,
}) => {
  // -------------------------- VAR --------------------------
  const customWeekStartEndFormat = (value) =>
    `${value.clone().startOf(startOfString).format(weekFormat)} - ${value
      .clone()
      .endOf(startOfString)
      .format(weekFormat)}`;

  const isMonthReport = reportBy === "month";

  // -------------------------- MAIN --------------------------
  return (
    <div className="payout-report-toolbar-grid">
      <div className="payout-report-field">
        <span className="payout-report-label">Report By</span>
        <Select
          options={REPORT_BY_OPTIONS}
          value={reportBy}
          onChange={handleReportByChange}
          className="payout-report-period-select"
        />
      </div>
      <div className="payout-report-period-row">
        <div className="payout-report-field">
          <span className="payout-report-label">Period</span>
          <DatePicker
            format={isMonthReport ? "MMM YYYY" : customWeekStartEndFormat}
            picker={isMonthReport ? "month" : "week"}
            onChange={handlePeriodChange}
            value={moment(isMonthReport ? currentMonthStart : currentWeekStart)}
            allowClear={false}
            className="payout-report-period-select"
          />
        </div>
        <div className="payout-report-btn-pair">
          <Button
            type="primary"
            className="payout-report-nav-btn"
            onClick={handlePreviousPeriod}
          >
            Previous
          </Button>
          <Button
            type="primary"
            className="payout-report-nav-btn payout-complete-btn"
            disabled={nextDisabled}
            onClick={handleNextPeriod}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PayoutReportToolbar;
